module.exports = __webpack_public_path__ + "img/cite2.5f2a4379.png";